import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { FormattedMessagePropType } from '../../../prop-types/intl';
import { POPOVER_TOOLTIP } from './constants';
import { TruncatedText } from '../truncated-text';

import styles from './interactable-popover.module.less';

export const ContentBody = ({
  ignoreFlyout = false,
  isDark = false,
  popoverType,
  useMessagesForTooltipText,
  previewMessage,
  popoverBody,
}) => {
  const popoverClassname = `${popoverType}-popover`;
  const shouldTruncate = popoverType === POPOVER_TOOLTIP && !useMessagesForTooltipText && !ignoreFlyout;

  const body = useMemo(() => {
    if (typeof popoverBody === 'function') {
      return popoverBody(popoverType);
    }
    return popoverBody;
  }, [popoverBody, popoverType]);

  return (
    <div className={classnames(styles['popover-content'], styles[popoverClassname], { [styles.dark]: isDark })}>
      {shouldTruncate ? (
        <>
          <TruncatedText value={body} />
          <div
            className={classnames(styles['see-full-msg'], {
              [styles['see-full-msg-dark']]: isDark,
            })}
          >
            {previewMessage}
          </div>
        </>
      ) : (
        body
      )}
    </div>
  );
};

ContentBody.propTypes = {
  ignoreFlyout: PropTypes.bool,
  isDark: PropTypes.bool,
  popoverBody: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  popoverType: PropTypes.string.isRequired,
  previewMessage: FormattedMessagePropType.isRequired,
  useMessagesForTooltipText: PropTypes.bool.isRequired,
};
